module.exports = __webpack_public_path__ + "static/media/loading.145277e3.gif";